<template>
  <div
    :class="classes"
    :style="styles"
  >
    <slot/>
  </div>
</template>

<script>

  export default {
    name: 'cTitle',
    props: {
      color: {
        type: String,
        default: '#000',
        description: 'hexadecimal color (#FFF)'
      },
      size: {
        type: String,
        default: 'lg',
        description: '(h1 / h2 / h3 / xs / sm / md / lg / xl)'
      },
      weight: {
        type: String,
        default: 'lighter',
        description: '(bolder / lighter / normal)'
      },
      align: {
        type: String,
        default: 'left'
      }
    },
    computed: {
      classes() {
        return [
          'c-title',
          `c-title--${this.size}`,
          `c-title--${this.weight}`,
          `c-title--${this.align}`
        ]
      },
      styles() {
        return {
          color: this.color
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .c-title {
    display: flex;
    letter-spacing: -2.5px;
    position: relative;

    &--xs {
      font-size: 28px;
      line-height: 28px;

      @media (min-width: 768px) {
        font-size: 32px;
        line-height: 32px;
      }

      @media (min-width: 992px) {
        font-size: 36px;
        line-height: 36px;
      }

      @media (min-width: 1200px) {
        font-size: 40px;
        line-height: 40px;
      }
    }

    &--sm {
      font-size: 32px;
      line-height: 32px;

      @media (min-width: 768px) {
        font-size: 36px;
        line-height: 36px;
      }

      @media (min-width: 992px) {
        font-size: 40px;
        line-height: 40px;
      }

      @media (min-width: 1200px) {
        font-size: 44px;
        line-height: 44px;
      }
    }

    &--md {
      font-size: 36px;
      line-height: 36px;

      @media (min-width: 768px) {
        font-size: 40px;
        line-height: 40px;
      }

      @media (min-width: 992px) {
        font-size: 44px;
        line-height: 44px;
      }

      @media (min-width: 1200px) {
        font-size: 48px;
        line-height: 48px;
      }
    }

    &--lg {
      font-size: 44px;
      line-height: 44px;

      @media (min-width: 768px) {
        font-size: 48px;
        line-height: 48px;
      }

      @media (min-width: 992px) {
        font-size: 52px;
        line-height: 52px;
      }

      @media (min-width: 1200px) {
        font-size: 56px;
        line-height: 56px;
      }
    }

    &--xl {
      font-size: 48px;
      line-height: 48px;

      @media (min-width: 768px) {
        font-size: 52px;
        line-height: 52px;
      }

      @media (min-width: 992px) {
        font-size: 56px;
        line-height: 56px;
      }

      @media (min-width: 1200px) {
        font-size: 60px;
        line-height: 60px;
      }
    }

    &--bolder {
      font-weight: bolder;
    }

    &--lighter {
      font-weight: lighter;
    }

    &--normal {
      font-weight: normal;
    }

    &--left {
      text-align: left;
      justify-content: flex-start;
    }

    &--center {
      text-align: center;
      justify-content: center;
    }

    &--right {
      text-align: right;
      justify-content: flex-end;
    }
  }
</style>


